module.exports = __webpack_public_path__ + "img/DE04025.23b93484.svg";